import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import { City } from "../../types";
import styles from "./CitySelector.module.css";
import SearchIcon from "../icons/glass.svg?react";
import { HapticFeedback } from "../../utils/hapticFeedback";

interface CitySelectorProps {
  selectedCity: City | null;
  onCitySelect: (city: City) => void;
  isOpen: boolean;
  onClose: () => void;
  loading?: boolean;
}

export const CitySelector: React.FC<CitySelectorProps> = ({
  selectedCity,
  onCitySelect,
  isOpen,
  loading = false,
}) => {
  const cities = useSelector((state: RootState) => state.gifts.cities);
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredCities, setFilteredCities] = useState<City[]>(cities);
  const searchInputRef = useRef<HTMLInputElement>(null);

  // useBackButton({
  //   isOpen,
  //   onBack: onClose,
  // });

  const handleCitySelect = (city: City) => {
    HapticFeedback.medium(); // Средний тап для важного выбора города
    onCitySelect(city);
  };

  // Фильтрация городов
  useEffect(() => {
    if (!searchQuery.trim()) {
      setFilteredCities(cities);
    } else {
      const filtered = cities.filter((city) =>
        city.name.toLowerCase().includes(searchQuery.toLowerCase())
      );
      setFilteredCities(filtered);
    }
  }, [searchQuery, cities]);

  // Сброс поиска при открытии
  useEffect(() => {
    if (isOpen) {
      setSearchQuery("");
      setFilteredCities(cities);
    }
  }, [isOpen, cities]);

  if (!isOpen) return null;

  return (
    <div className={styles.overlay}>
      <div className={styles.container}>
        <div className={styles.header}>
          <h2 className={styles.title}>Город</h2>
          <div className={styles.searchContainer}>
            <input
              ref={searchInputRef}
              type="text"
              placeholder="Поиск"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className={styles.searchInput}
            />
            <SearchIcon className={styles.searchIcon} />
          </div>
        </div>

        <div className={styles.content}>
          <div className={styles.cityList}>
            {filteredCities.map((city) => {
              const isSelected = selectedCity?.id === city.id;

              return (
                <button
                  key={city.id}
                  className={`${styles.cityItem} ${
                    isSelected ? styles.selected : ""
                  }`}
                  onClick={() => handleCitySelect(city)}
                >
                  <span className={styles.cityName}>{city.name}</span>
                  {isSelected && (
                    <svg
                      className={styles.checkIcon}
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M20 6L9 17L4 12"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  )}
                </button>
              );
            })}
          </div>
        </div>

        {loading && (
          <div className={styles.loading}>
            <div className={styles.spinner}></div>
            <span>Загрузка...</span>
          </div>
        )}
      </div>
    </div>
  );
};
